var _defs, _path, _line, _polyline, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioTextTracking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 383.01 482.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 32px;\r\n      }\r\n\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M359.01,286.42c-5.12,0-10.1-1.47-14.21-4.2-.23-.14-.44-.3-.66-.46l-91.46-67.04h-69.67c-13.25,0-24-9.62-24-21.48V93.16c0-11.86,10.75-21.48,24-21.48h69.65L344.12,4.64c.22-.16,.43-.31,.66-.46,10.67-7.03,25.7-4.99,33.56,4.56,3.04,3.69,4.68,8.16,4.67,12.75v243.44c0,11.86-10.75,21.48-24,21.48Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60.42,
    y1: 87.43,
    x2: 60.44,
    y2: 402.53
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "104.88 365.54 60.44 409.98 16 365.54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250.91,294.95h-47.26v128.53h-31.79v-128.53h-46.62v-25.75h125.67v25.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M270.02,348.84l19.28-31.76h32.74l-32.63,52.12,34.01,54.28h-32.85l-20.45-33.44-20.34,33.44h-32.95l34.01-54.28-32.53-52.12h32.85l18.86,31.76Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioTextTracking);
export default __webpack_public_path__ + "static/media/audio-text-tracking.de9269e39a4d4be59fce5dde7d5f47b4.svg";
export { ForwardRef as ReactComponent };